export default __webpack_public_path__ + "static/taskdefinition21-2e6d8ecebdb63bd81de62c786c0a320e.png";